import { Shield } from 'lucide-react'
import Paper from '@/components/Paper'

interface EmptyStateProps {
    icon?: React.ElementType
    title: string
    description?: string
    action?: React.ReactNode
}

const EmptyState = ({
    icon: Icon = Shield,
    title,
    description,
    action,
}: EmptyStateProps) => {
    return (
        <Paper className="p-8 text-center">
            <Icon
                className="w-12 h-12 text-gray-300 mx-auto mb-4"
                aria-hidden="true"
            />
            <h3 className="text-lg font-medium text-gray-700 mb-2">{title}</h3>
            {description && (
                <p className="text-sm text-gray-500 mb-4">{description}</p>
            )}
            {action && <div className="flex justify-center">{action}</div>}
        </Paper>
    )
}

export default EmptyState
